// import Tests from 'helpers/Tests';

export const CONFIG = {
	IS_AJAX: false,
	IS_LOADER: false,
	IS_LAZY_LOADING: false,
	IS_SMOOTH_SCROLL: false,
	DEBUG: DEV
};
